import React, { Component } from 'react';
import './App.css';
import Main from './components/main/Main';
import Header from './components/header/Header';
import HeaderOnlyLogo from './components/header/HeaderOnlyLogo';
import Loader from './components/shared/loader/Loader';
import Messages from './components/shared/messages/Messages';
import AssistantWidget from './components/shared/assistant/AssistantWidget';

class App extends Component {
  render() {
    const currentPath = window.location.pathname;

    return (
      <div>
        {currentPath.includes('order-materials/review') ||
        currentPath.includes('public/rfa') ? (
          <HeaderOnlyLogo />
        ) : (
          <Header />
        )}
        <Main />

        <Loader />
        <Messages />
        <AssistantWidget />
      </div>
    );
  }
}

export default App;
